import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface WishListIconStyles {
    wishListIcon?: InjectableCss;
}

export const wishListIconStyles: WishListIconStyles = {
    wishListIcon: {
        css: css`
            display: flex;
            & path {
                fill: #636161;
            }
            & svg {
                height: 12px !important;
                
            }
        `,
    },
};

const styles = wishListIconStyles;

const WishListIcon: React.FC = () => {
    return (
        <StyledWrapper {...styles.wishListIcon}>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.8319 1.47401C10.2858 0.983229 9.58501 0.729635 8.8772 0.750729C7.99853 0.750729 7.11165 1.11167 6.46314 1.78151L6.00142 2.25659L5.5397 1.78151C4.89048 1.11167 4.00454 0.750729 3.12564 0.750729C2.41782 0.750729 1.71775 0.983463 1.15079 1.47401C-0.305613 2.73471 -0.378504 4.9826 0.934465 6.33963L5.46259 11.0201C5.61236 11.1734 5.80454 11.2507 5.99907 11.2507C6.19436 11.2507 6.39025 11.1742 6.53837 11.0209L11.0642 6.34048C12.3811 4.9812 12.3085 2.73354 10.8319 1.47401ZM10.2577 5.55776L6.00142 9.95932L1.74376 5.55776C0.988137 4.77729 0.809074 3.23745 1.8872 2.32456C2.82236 1.51503 4.10415 1.9144 4.73251 2.56292L6.00212 3.87354L7.2715 2.56292C7.89072 1.92378 9.17603 1.51081 10.1168 2.32456C11.1835 3.24917 11.0288 4.76089 10.2577 5.55776Z" fill="#636161" />
            </svg>
        </StyledWrapper>
    );
};

export default React.memo(WishListIcon);
